import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function jsonInfo ({ idCard, lastConnectionCard, soCard, statusDeviceCard, serialNumberCard, modelCard, codeEstablishment, addressEstablishment }) {
  // console.log(idCard, lastConnectionCard, soCard, statusDeviceCard)
  const { t } = useTranslation('dashboardDevice')
  const result = []

  if (idCard) {
    result.push({
      key: 'identity',
      title: t('cardsInfo.label9'),
      icon: [
        'fa-solid fa-mobile'
      ],
      compare: false
    })
  }
  if (modelCard) {
    result.push({
      key: 'model',
      title: t('cardsInfo.label10'),
      icon: [
        'fa-solid fa-mobile'
      ],
      compare: true
    })
  }
  if (serialNumberCard) {
    result.push({
      key: 'serial_number',
      title: t('cardsInfo.label11'),
      icon: [
        'fas fa-microchip'
      ],
      compare: false
    })
  }
  if (lastConnectionCard) {
    result.push({
      key: 'last_date',
      title: t('cardsInfo.label12'),
      icon: [
        'fa-solid fa-clock'
      ],
      compare: false
    })
  }
  if (soCard) {
    result.push({
      key: 'so',
      title: t('cardsInfo.label13'),
      icon: [
        'fa-brands fa-android',
        'fa-brands fa-windows'
      ],
      compare: true
    })
  }
  if (statusDeviceCard) {
    result.push({
      key: [
        'status_lock',
        'motive_lock'
      ],
      title: t('cardsInfo.label14'),
      icon: [
        'fa-sharp fa-solid fa-lock',
        'fa-sharp fa-solid fa-unlock',
        'fa-sharp fa-solid fa-info-circle'
      ],
      compare: true
    })
  }
  if (codeEstablishment) {
    result.push({
      key: 'codeEstablishment',
      title: t('cardsInfo.label15'),
      icon: [
        'fas fa-building'
      ],
      compare: true
    })
  }
  if (addressEstablishment) {
    result.push({
      key: 'addressEstablishment',
      title: t('cardsInfo.label16'),
      icon: [
        'fas fa-map-pin'
      ],
      compare: true
    })
  }
  return result
}

jsonInfo.propTypes = {
  idCard: PropTypes.bool,
  lastConnectionCard: PropTypes.bool,
  soCard: PropTypes.bool,
  statusDeviceCard: PropTypes.bool
}
